import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { useApi } from '../api/useApi';
import { ApiClient } from '../api/ApiClient';

export function useResourceMutation<TInput, TOutput>(
  mutator: (api: ApiClient, input: TInput) => Promise<TOutput>,
  invalidateKeys: ReadonlyArray<ReadonlyArray<unknown>> = [],
): UseMutationResult<TOutput, Error, TInput> {
  const api = useApi();
  const queryClient = useQueryClient();
  return useMutation<TOutput, Error, TInput>({
    mutationFn: (input) => mutator(api, input),
    onSuccess: async () => {
      await Promise.all(
        invalidateKeys.map((key) =>
          queryClient.invalidateQueries({ queryKey: key as unknown[] }),
        ),
      );
    },
  });
}
